module.exports = __webpack_public_path__ + "media/bootstrap-icons/ui-radios-7c2c1ebf.svg";